import React, { Suspense } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ToastProvider from './components/Toast/ToastProvider';
// import Header from './components/layaout/Header'; // ❌ HEADER RETIRÉ
import PrivateRoute from './components/PrivateRoute';
import Loader from './components/layaout/Loader';

// 🚀 PERF : code-splitting — TOUS les écrans (sauf Loader, requis par le
// fallback Suspense) sont chargés en lazy → bundle initial allégé
const PayementInitiation = React.lazy(() => import('./components/Dashboard/PayementInitiation'));
const CategoryPage = React.lazy(() => import('./screens/Page/CategoryPage'));
const Contact = React.lazy(() => import('./screens/InformationPage/Contact'));
const PrivacyPolicy = React.lazy(() => import('./screens/InformationPage/PrivacyPolicy'));
const TermsOfUse = React.lazy(() => import('./screens/InformationPage/TermOfUse'));
const BecomeSellerScreen = React.lazy(() => import('./screens/vendeurs/BecomeSellerScreen'));
const Shop = React.lazy(() => import('./screens/Page/Shop'));
const CartScreen = React.lazy(() => import('./screens/vendeurs/CartScreen'));
const Settings = React.lazy(() => import('./screens/Page/Settings'));
const FavorisPage = React.lazy(() => import('./screens/Page/FavorisPage'));
const PaiementAnnuler = React.lazy(() => import('./components/Dashboard/PaiementAnnuler'));
const DeleteAccountForm = React.lazy(() => import('./screens/InformationPage/DeleteAccountForm'));
const ComplaintFormScreen = React.lazy(() => import('./screens/InformationPage/ComplaintFormScreen'));
const ComplaintHistoryScreen = React.lazy(() => import('./screens/InformationPage/ComplaintHistoryScreen'));
const LivreurDashboard = React.lazy(() => import('./components/LivreurDashboard/LivreurDashboard'));
const SupportPage = React.lazy(() => import('./screens/InformationPage/SupportPage'));
const AvisScreen = React.lazy(() => import('./screens/avis/AvisScreen'));
const DownloadPage = React.lazy(() => import('./screens/Page/DownloadPage'));
const ResetPasswordScreen = React.lazy(() => import('./screens/Clients/ResetPasswordScreen'));
const ForgotPasswordScreen = React.lazy(() => import('./screens/Clients/ForgotPasswordScreen'));
const BecomeDeliveryConfirm = React.lazy(() => import('./screens/vendeurs/BecomeDeliveryConfirm'));
const BecomeChefDelivery = React.lazy(() => import('./screens/vendeurs/BecomeChefDelivery'));
const SuggestionsPage = React.lazy(() => import('./screens/Page/SuggestionsPage'));
const KitDetailScreen = React.lazy(() => import('./screens/Page/KitDetailScreen'));
const CheckoutFlowScreen = React.lazy(() => import('./screens/Page/CheckoutFlowScreen'));
const KitsLandingPage = React.lazy(() => import('./screens/Page/KitsLandingPage'));

// Chargement dynamique des écrans avec React.lazy
const LoginScreen = React.lazy(() => import('./screens/Clients/LoginScreen'));
const LoginSaniso = React.lazy(() => import('./screens/Clients/LoginSaniso'));
const ProfileScreen = React.lazy(() =>
  import('./screens/Clients/ProfileScreen'),
);
const RegisterScreen = React.lazy(() =>
  import('./screens/Clients/RegisterScreen'),
);
const HomeScreen = React.lazy(() => import('./screens/Page/HomeScreen'));
const CheckoutScreen = React.lazy(() =>
  import('./screens/Page/CheckoutScreen'),
);

// Nouveaux imports pour le dashboard et les rôles spécifiques
const ProductForm = React.lazy(() =>
  import('./components/Dashboard/ProductForm'),
);
const SellerDashboard = React.lazy(() =>
  import('./components/Dashboard/SellerDasboard'),
);



const OrderSuccess = React.lazy(() => import('./screens/Page/OrderSuccess'));
const ProductScreen = React.lazy(() => import('./screens/Page/ProductScreen'));
const SearchResultsScreen = React.lazy(() =>
  import('./screens/Page/SearchResultsScreen'),
);
const AdminDashboardNew = React.lazy(() => import('./admin'));


const App = () => {
  return (
    <ToastProvider>
      <Router>
      <main className="py-0">
        <Suspense
          fallback={
            <div>
              <Loader />
            </div>
          }
        >
          <Routes>
            {/* Routes Client / Visiteur */}
            
            {/* Page d'Accueil */}
            <Route
              path="/"
              element={
                <>
                  <HomeScreen />
                </>
              }
              exact
            />
            
            {/* Panier */}
            <Route
              path="/panier"
              element={
                <>
                  <CartScreen />
                </>
              }
              exact
            />
            
            {/* Suggestions */}
            <Route
              path="/suggestions"
              element={
                <>
                  <SuggestionsPage />
                </>
              }
              exact
            />
            
            {/* Paramètres */}
            <Route
              path="/parametre"
              element={
                <>
                  <Settings />
                </>
              }
              exact
            />
            
            {/* Favoris */}
            <Route
              path="/favoris"
              element={
                <>
                  <FavorisPage />
                </>
              }
              exact
            />
            
            {/* Détail Produit */}
            <Route
              path="/product/:slug"
              element={
                <>
                  <ProductScreen />
                </>
              }
            />
            {/* Détail kit */}
            <Route
              path="/kit/:slug"
              element={
                <>
                  <KitDetailScreen />
                </>
              }
            />
            <Route
              path="/page-de-paiement"
              element={
                <>
                  <CheckoutFlowScreen />
                </>
              }
            />
            
            {/* Recherche */}
            <Route
              path="/search"
              element={
                <>
                  <SearchResultsScreen />
                </>
              }
            />
            <Route
              path="/kits-categorie"
              element={
                <>
                  <KitsLandingPage />
                </>
              }
            />

            {/* Commandes */}
            <Route
              path="/commandes"
              element={
                <>
                  <OrderSuccess />
                </>
              }
            />
            
            {/* Boutique */}
            <Route
              path="/boutique/:shopName"
              element={
                <>
                  <Shop />
                </>
              }
            />

            {/* Paiement */}
            <Route
              path="/CheckoutScreen"
              element={
                <>
                  <CheckoutScreen />
                </>
              }
            />
            
            {/* Catégorie */}
            <Route
              path="/category/:categorySlug"
              element={
                <>
                  <CategoryPage />
                </>
              }
            />

            {/* Information */}
            <Route path="/confidentialiter" element={<PrivacyPolicy />} />
            <Route path="/condition" element={<TermsOfUse />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/supprimerCompte" element={<DeleteAccountForm />} />
            <Route path="/support" element={<SupportPage/>} />
            {/* ⭐ Page d'avis après livraison — accessible via le badge QR du livreur */}
            <Route path="/avis/:token" element={<AvisScreen />} />

            {/* Authentification */}
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/codeoublier" element={<ForgotPasswordScreen />} />
            <Route path="/changercode" element={<ResetPasswordScreen />} />
            <Route path="/login-saniso" element={<LoginSaniso />} />
            <Route path="/register" element={<RegisterScreen />} />
            <Route path="/become-delivery" element={<BecomeDeliveryConfirm />} />
            <Route path="/become-Chefdelivery" element={<BecomeChefDelivery />} />
            
            {/* Profile */}
            <Route
              path="/profile"
              element={
                <>
                  <ProfileScreen />
                </>
              }
            />
            
            {/* Réclamation */}
            <Route path="/reclamation" element={<ComplaintFormScreen />} />
            <Route
              path="/reclamation/historique"
              element={<ComplaintHistoryScreen />}
            />

            {/* Dashboard vendeurs (Routes privées) */}
            <Route
              path="/livreur-Dashboard"
              element={<PrivateRoute allowedRoles={['livreur']} />}
            >
              <Route path="" element={<LivreurDashboard />} />
            </Route>
            <Route
              path="/vendeur-dashboard"
              element={<PrivateRoute allowedRoles={['vendeur']} />}
            >
              <Route path="" element={<SellerDashboard />} />
            </Route>
            <Route
              path="/Payement/:slug"
              element={<PrivateRoute allowedRoles={['vendeur']} />}
            >
              <Route path="" element={<PayementInitiation />} />
            </Route>
            <Route
              path="/Payement/abonnement"
              element={<PrivateRoute allowedRoles={['vendeur']} />}
            >
              <Route path="" element={<PayementInitiation />} />
            </Route>
            <Route
              path="/PaiementAnnuler"
              element={<PrivateRoute allowedRoles={['vendeur']} />}
            >
              <Route path="" element={<PaiementAnnuler />} />
            </Route>
            <Route
              path="/ajoutproduit"
              element={<PrivateRoute allowedRoles={['vendeur']} />}
            >
              <Route path="" element={<ProductForm />} />
            </Route>
            <Route path="/devenir-vendeur" element={<BecomeSellerScreen />} />
            <Route path="/Saniso-mobile" element={<DownloadPage />} />

            {/* Admin (Routes privées) — l'ancien dashboard dashboardSaniso a été supprimé,
                seules les redirections vers /admin/* sont conservées */}
            <Route
              path="/admin/*"
              element={
                <PrivateRoute allowedRoles={['admin', 'super_admin', 'finance', 'delivery_chef', 'delivery_director', 'support']}>
                  <AdminDashboardNew />
                </PrivateRoute>
              }
            />

            {/* 🔥 REDIRECTION POUR L'ANCIENNE ROUTE */}
            <Route
              path="/admin-dashboard"
              element={
                <PrivateRoute allowedRoles={['admin', 'super_admin']}>
                  <Navigate to="/admin/dashboard" replace />
                </PrivateRoute>
              }
            />

            {/* 🔥 REDIRECTION POUR FINANCE */}
            <Route
              path="/financeDashboard"
              element={
                <PrivateRoute allowedRoles={['finance', 'admin', 'super_admin']}>
                  <Navigate to="/admin/finance" replace />
                </PrivateRoute>
              }
            />

            {/* 🔥 REDIRECTION POUR LIVRAISON */}
            <Route
              path="/LivraisonDashboard"
              element={
                <PrivateRoute allowedRoles={['delivery_chef', 'delivery_director', 'admin', 'super_admin']}>
                  <Navigate to="/admin/deliveries" replace />
                </PrivateRoute>
              }
            />
          </Routes>
        </Suspense>
      </main>
      </Router>
    </ToastProvider>
  );
};

export default App;